import React, { useEffect, useState, Fragment, useContext } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import loaderGIF from "assets/images/imageIcons/purple-loader.gif";
import FileUpload from "components/sales/fileUpload/fileUpload";
import DatePicker from "components/sales/datePicker/datePicker";
import ModalPop from "components/sales/modal/modal";
import { toast } from "react-toastify";
import Images from 'assets/images/imageData';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const BankSheetUpload = ({
  match,
  bankSheetDetailsUpload,
  uploadTheBankSheet = [],
  documentUrlDataPublic = [],
  documentUploadUrlPublic,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileExtension, setFileExtension] = useState("");
  const { baseUrl } = useContext(BaseUrl);
  const [compressedImageUrl, setCompressedImageUrl] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [inputList, setInputList] = useState([
    {
      file_url: "",
      effective_start_date: "",
      effective_end_date: "",
    },
  ]);

  const handleInputValue = (key, val) => {
    let list = [...inputList];
    inputList[0][key] = val;
    setInputList(list);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (inputList) {
      console.log("INPUT: ", inputList);
      if(inputList[0]['effective_start_date'] == '') {
        toast.error("Effective start date is required");
        return false;
      }
      if(inputList[0]['effective_end_date'] == '') {
        toast.error("Effective end date is required");
        return false;
      }
      if(inputList[0]['file_url'] == '') {
        toast.error("Bank sheet is required");
        return false;
      }
      const response = await bankSheetDetailsUpload(inputList);
      

      if (response?.status == true) {
        setIsModal(true);
      } else {
        toast.error(response.data);
      }
    } else {
      toast.error("No file selected"); 
      setLoading(false);
    }
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(compressedImageUrl);
    setShowToast(true);
  };

  const handleModalHide = () => setIsModal(false);

  useEffect(() => {
    if (showToast) {
      const timer = setTimeout(() => {
        setShowToast(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [showToast]);

  const handleCompressMore = () => {
    setSelectedFile(null);
    setFileExtension("");
    setCompressedImageUrl("");
    setError("");
    const fileInput = document.getElementById("fileUpload");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  useEffect(() => {
    console.log(uploadTheBankSheet)
    if (parseInt(uploadTheBankSheet?.status) === 200) {
      toast.success(uploadTheBankSheet?.message);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else if (uploadTheBankSheet?.status !== 200) {
      toast.error(uploadTheBankSheet?.message);
    }
  }, [uploadTheBankSheet]);

  return (
    <Layout title={"Bank Sheet Uploader"}>
      <div style={styles.container}>
        <div style={styles.card}>
          <h2 style={styles.header}>Bank Sheet Upload</h2>

          <form
            className="compress-image-form"
            onSubmit={handleSubmit}
            style={styles.form}
          >
            <div className="col-md-12">
              <DatePicker
                label={"Start Date"}
                required={false}
                handleChange={(val) => {
                  handleInputValue("effective_start_date", val);
                }}
              />
            </div>
            <div className="col-md-12">
              <DatePicker
                label={"End Date"}
                required={false}
                handleChange={(val) => {
                  handleInputValue("effective_end_date", val);
                }}
              />
            </div>
            <div className="col-md-12 col-sm-12 d-flex">
              <FileUpload
                id={"addAttachment"}
                accept=".csv"
                documentUploadUrl={documentUploadUrlPublic}
                documentUrlData={documentUrlDataPublic}
                onChange={(val) => handleInputValue("file_url", val)}
                required
                isStarRequired={true}
              >
                <span className="btn btn-transparent">
                  {'Upload Sheet'}
                </span>
              </FileUpload>
            </div>
            <div className="d-flex" style={{'justifyContent': 'end'}}>
              <button
                type="submit"
                className="btn btn-primary uploader"
                style={compressedImageUrl ? styles.buttonDisabled : styles.button}
                disabled={!!compressedImageUrl}
              >
                Submit
              </button>
            </div>
          </form>
          {/* {loading && (
            <div>
              <img src={loaderGIF} alt="Loading..." />
            </div>
          )} */}
        </div>
      </div>
      {showToast && <div style={styles.toast}>URL copied to clipboard!</div>}
      {/*<ModalPop*/}
      {/*  title={localization.conf}*/}
      {/*  show={isModal}*/}
      {/*  handleModalHide={handleModalHide}*/}
      {/*  keyboard*/}
      {/*  backdrop*/}
      {/*>*/}
      {/*  <div className="text-center">*/}
      {/*    <div className="success">*/}
      {/*      <img src={Images?.tick} alt="" />*/}
      {/*    </div>*/}
      {/*    <h5>{'Sheet uploaded successfully'}</h5>*/}
      {/*    <Link*/}
      {/*      to={`${baseUrl}/ucd/bank-sheet-upload`}*/}
      {/*      className="btn btn-primary mb-4"*/}
      {/*    >*/}
      {/*      {localization.goToMeetingList}{" "}*/}
      {/*      <img src={Images?.ArrowRight} alt="" />*/}
      {/*    </Link>*/}
      {/*  </div>*/}
      {/*</ModalPop>*/}
    </Layout>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    height: "100vh",
    paddingTop: "40px",
    backgroundColor: "#f8f8ff",
  },
  card: {
    backgroundColor: "#dcd6f7",
    padding: "50px",
    borderRadius: "16px",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
    width: "600px",
    textAlign: "center",
  },
  header: {
    marginBottom: "30px",
    color: "#4b0082",
    fontSize: "24px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  formGroup: {
    marginBottom: "20px",
  },
  label: {
    color: "#4b0082",
    marginBottom: "10px",
    fontSize: "18px",
  },
  input: {
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #bbb",
    width: "100%",
  },
  button: {
    padding: "12px 20px",
    backgroundColor: "#4b0082",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "16px",
    marginTop: "20px",
    alignSelf: "center",
    width: "100% !important",
  },
  buttonDisabled: {
    padding: "12px 20px",
    backgroundColor: "#bbbbbb",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "not-allowed",
    fontSize: "16px",
    marginTop: "20px",
    alignSelf: "center",
    width: "fit-content",
  },
  resultContainer: {
    marginTop: "20px",
  },
  urlContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    color: "#4b0082",
    marginBottom: "20px",
    width: "100%",
    boxSizing: "border-box",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
  },
  urlLabel: {
    fontSize: "16px",
    marginBottom: "10px",
  },
  urlText: {
    fontSize: "16px",
    marginBottom: "10px",
    fontFamily: "monospace",
    wordBreak: "break-all",
  },
  copyButton: {
    padding: "8px 16px",
    backgroundColor: "#4b0082",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "14px",
  },
  compressMoreButton: {
    padding: "12px 20px",
    backgroundColor: "#4b0082",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "16px",
    width: "100%",
  },
  error: {
    marginTop: "20px",
    color: "red",
    fontSize: "14px",
  },
  toast: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    backgroundColor: "white",
    color: "green",
    padding: "15px 30px",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    zIndex: 1000,
    transition: "all 0.5s ease-in-out",
  },

  uploader: {
    width: "100%",
  },
};

export default BankSheetUpload;
